import React from "react";
import { Helmet } from "react-helmet";
import DashboardCard from "./DashboardCard";
import GridItem from "../../components/ui/Grid/GridItem";
import Page from "../../components/Page";
import Header from "../../components/Header";
import ContentLoader from "../../components/ContentLoader";

import { CardsTitle, CardsWrap, Alert, CardsContainer } from "./styles";
import { useDashboard } from "./useDashboard";
import { getCourseState } from "../../../utils/userStoryUtils";
import {DashboardHeader} from "./DashboardHeader";
import {eventsCollection} from "../../../utils/fire";

export default function Dashboard() {
	const { course, lessons, userStory, verifyUser, loading, user } = useDashboard();

	const mapCards = (card, i) => (
		<GridItem key={i} md={6} lg={4} sm={12}>
			<DashboardCard {...card} status={!verifyUser ? "disabled" : card.status} />
		</GridItem>
	);

	const noMaterialsCard = (
		<GridItem md={6} lg={8} sm={12}>
			<DashboardCard title="" text="Наразі немає доступних матеріалів" showActionButton={false} status={"disabled"} />
		</GridItem>
	);
	const noCourseCard = (
		<GridItem md={6} lg={8} sm={12}>
			<DashboardCard title="" text="Наразі немає доступного курсу" showActionButton={false} status={"disabled"} />
		</GridItem>
	);

	if (loading) return <ContentLoader />;

	const { isSuperUser } = user;

	let main = [];
	let additional = [];
	let title = "";
	let subTitle = "";

	if (course) {
		const { courseId, lessons: courseLessonsIds } = course;
		const storyCourse = userStory.courses[courseId];

		const state = getCourseState(course, lessons, userStory, isSuperUser);

		const { structureDescription, glosariyDescription, slug } =
			course;

		title = course.title;
		subTitle =  course.subTitle;

		const finalTestStatus = storyCourse.complete
			? "done"
			: isSuperUser
				? "other"
				: Object.values(state).find((lesson) => !(lesson.status === "done"))
					? "disabled"
					: "other";

		console.log("STATE: ", state);

		main = [
			{
				slug,
				title: "Структура курсу",
				text: structureDescription,
				to: `/${slug}/structure`,
				status: "other",
			},
			...courseLessonsIds.map((id) => ({
				slug: state[id].slug,
				title: state[id].title,
				status: state[id].status,
				steps: state[id].steps,
				text: state[id].description,
				to: `/${slug}/${state[id].slug}`,
			})),
			{
				slug,
				title: "Іспит",
				text: "Доступний після завершення всіх модулів.",
				to: `/${slug}/test`,
				status: finalTestStatus,
			},
		];

		additional = [
			{
				slug,
				status: "other",
				title: "Глосарій",
				text: glosariyDescription,
				to: `/${slug}/glosariy`,
			},
			{
				slug,
				status: "other",
				title: "Бібліотека",
				text: "Додаткові матеріали для навчання",
				to: `/${slug}/library`,
			},
		];

	}

	return (
		<>
			<Helmet>
				<title>Кабінет | Навчальна платформа</title>
			</Helmet>
			<Header />
			<Page
				paddingBottom="150px"
				header={
					<>
						{!verifyUser && (
							<Alert severity="error">Ваш аккаунт не підтверджений</Alert>
						)}

						<DashboardHeader/>
					</>
				}
				supTitle={title}
				subTitle={subTitle}>
				<CardsWrap>
					<CardsContainer>{main.map(mapCards)}</CardsContainer>
					{main.length === 0 && noCourseCard}
				</CardsWrap>

				<CardsWrap paddingTop paddingBottom>
					<CardsTitle>Матеріали</CardsTitle>
					<CardsContainer>{additional.map(mapCards)}</CardsContainer>
					{additional.length === 0 && noMaterialsCard}
				</CardsWrap>
			</Page>
		</>
	);
}
